// @flow
import { ACCOUNTS_BACKEND_URL } from "../../Constants/Global/apiConstants";
import axios from "axios";
import { getPhoneNumberUnmasked } from "../../Utilities/Helpers/InputMaskHelpers";

export function userRegisterFormSubmit(formElements: Object, request_id: string, related_secret: string): Object {
  const apiSecrets = { "related_secret": related_secret };

  formElements.phone = getPhoneNumberUnmasked(formElements.phone);

  return axios.create({
    method: "post",
    headers: { "Content-Type": "application/json", "api-secrets": JSON.stringify(apiSecrets) },
    url: `${ACCOUNTS_BACKEND_URL}/register/${request_id}`,
    data: formElements
  });
}



// WEBPACK FOOTER //
// ./src/Api/PublicAccountPages/userregister.js